import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
const solutions = ['Dormir profundamente y despertar con energía estable.', 'Reducir inflamación, sofocos y desequilibrios hormonales.', 'Mejorar tu claridad mental y concentración.', 'Recuperar estabilidad emocional y disminuir ansiedad e irritabilidad.', 'Volver a sentirte conectada con tu cuerpo y tu feminidad.', 'Apoyar la pérdida de peso y desinflamar el abdomen sin dietas restrictivas.'];
const achievements = ['Comprender lo que ocurre en tu cuerpo y dejar de sentir incertidumbre.', 'Tener un plan claro para equilibrar tus hormonas de forma natural.', 'Implementar hábitos simples que mejoran tu descanso y energía.', 'Reducir síntomas físicos y emocionales que afectan tu calidad de vida.', 'Recuperar seguridad, bienestar y confianza en esta nueva etapa.', 'Sentirte nuevamente en control de tu cuerpo y tu vida.'];
export function Solutions() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 px-4 bg-[#FAF7F2]" ref={ref} data-id="element-130">
      <div className="max-w-3xl mx-auto" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2926] mb-4" data-id="element-133">
            RECUPERA TU EQUILIBRIO Y TRANSFORMA ESTA ETAPA
          </h2>
          <p className="text-xl text-[#7C9A6E] font-medium" data-id="element-134">
            Con esta guía podrás:
          </p>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-135">
          {solutions.map((solution, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 bg-[#7C9A6E]/5 rounded-lg border-l-4 border-[#6B8F5E]" data-id="element-136">
              <CheckCircleIcon className="w-6 h-6 text-[#6B8F5E] flex-shrink-0 mt-0.5" data-id="element-137" />
              <p className="text-[#2D2926]/90 leading-relaxed" data-id="element-138">{solution}</p>
            </motion.div>)}
        </div>

        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="text-2xl md:text-3xl font-bold text-center text-[#2D2926] mb-8" data-id="element-139">
          ¿QUÉ VAS A LOGRAR?
        </motion.h3>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-140">
          {achievements.map((achievement, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.7 + index * 0.1
        }} className="flex items-start gap-3 p-3" data-id="element-141">
              <CheckCircleIcon className="w-5 h-5 text-[#6B8F5E] flex-shrink-0 mt-0.5" data-id="element-142" />
              <p className="text-[#2D2926]/90 text-sm leading-relaxed" data-id="element-143">
                {achievement}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}